module.exports = __webpack_public_path__ + "img/pw.ef315fca.svg";